module.exports = __webpack_public_path__ + "static/media/logo-네이앤컴퍼니@3x.06d63adc.png";